<div *ngIf="showIndicator" class="validation-message icon-system_error" [ngbPopover]="tooltip" triggers="click hover" container="body" popoverClass="validation-error"></div>
<span>{{params.valueFormatted}}</span>

<ng-template #tooltip>
  <div class="message-text">
    <p>{{"external.forecast.ct.total.invalid"|translate}}<br>
      <br>
      <b>{{"plan.dist.cell.validation.line3"|translate}}{{total}}%</b></p>
    <button *ngIf="canBalance" type="button" class="btn btn-secondary btn-small ef-balance-btn" (click)="balance()">{{"external.forecast.ct.balance"|translate}}</button>
    <p *ngIf="!canBalance">{{"external.forecast.ct.balance.unavailable"|translate}}</p>
  </div>
</ng-template>
